import { useEffect, useState, useRef } from "react";
import Sidebar from "./sidebar";
import LiveChat from "./livechat";
import ToggleIcon from "../assets/toggle.svg";
import NewChatIcon from "../assets/newChat.svg";
import FeedbackModal from "./feedbackModal";
import Logo from "../assets/Logo.svg";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FAQ from "./faq";
import {
  getAllChats,
  getAllMessages,
  setIntroFlag,
} from "../services/chatService";
import SettingsModal from "./SettingsModal";
import { message } from 'antd';

function ConversationPage() {
  const [toggle, setToggle] = useState(true);
  const [selectedChatMessages, setSelectedChatMessages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chats, setChats] = useState([]);
  const [newChat, setNewChat] = useState(false);
  const [selectedChatId, setSelectedChatId] = useState(null);
  const userId = localStorage.getItem("userId");
  const [initials, setInitials] = useState("");
  const userName = localStorage.getItem("name");
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(true);
  const sidebarRef = useRef(null);
  const [displayFAQ, setDisplayFAQ] = useState(false);
  const [isSettingsModalVisible, setIsSettingsModalVisible] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState({
    id: "",
    type: "",
  });

  // Information toast at every render
  useEffect(() => {
    message.info({
      content: "Responses may be inaccurate; don't rely on them completely.",
      duration: 5,
    });
    // eslint-disable-next-line
  }, []);

  // Close Sidebar on clicking outside the sidebar for mobile screens
  const handleClickOutside = (event) => {
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target) &&
      window.innerWidth < 768
    ) {
      setToggle(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

  // Get Initial for full user name
  const trimName = () => {
    const nameParts = userName.split(" ");
    const firstInitial = nameParts[0] ? nameParts[0][0] : "";
    const lastInitial =
      nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : "";
    const initialname = firstInitial + lastInitial;
    setInitials(initialname);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setToggle(false);
      } else {
        setToggle(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, []);

  // By default select the latest chat and fetch messages to display
  useEffect(() => {
    if (!selectedChatId && chats.length > 0) {
      setSelectedChatId(chats[chats.length - 1]._id);
      handleSelectChat(chats[chats.length - 1]._id);
    }
    // eslint-disable-next-line
  }, [chats]);

  // Fetch all the chats to display in sidebar.
  useEffect(() => {
    fetchAllChats();
    trimName();
    // eslint-disable-next-line
  }, []);

  // Method to fetch all the chats for logged in user
  const fetchAllChats = async () => {
    try {
      const allChats = await getAllChats(userId);
      setChats(allChats.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // Set intro flag
  const handleSetIntroFlag = async (chat) => {
    if (chat.introFlag === false) {
      try {
        await setIntroFlag(chat._id);
      } catch (error) {
        console.log("Error updating the Intro Flag:", error);
      }
    }
  };

  // Method to fetch all the messages for a particular chat ID
  const fecthAllMessages = async (id) => {
    try {
      const response = await getAllMessages(id);
      setSelectedChatMessages(response.data);
    } catch (error) {
      console.log("Error Fetching Messages: ", error);
    }
  };

  // Method to fetch all the messages for selected chat in sidebar
  const handleSelectChat = (id) => {
    fecthAllMessages(id);
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleNewChat = () => {
    if (!newChat) {
      setNewChat(true);
      setSelectedChatId(null);
      if(toggle && window.innerWidth < 768) {
        handleToggle();
      }
    }
  };

  return (
    <div className="relative z-0 w-full max-h-[100vh] flex flex-col md:flex-row font-Poppins">
      {isModalOpen ? (
        <FeedbackModal
          setIsModalOpen={setIsModalOpen}
          setFeedback={setFeedback}
          feedback={feedback}
          selectedFeedback={selectedFeedback}
        />
      ) : (
        <div className="relative w-full max-h-[100vh] flex">
          {/* Mobile header - only shown on mobile when sidebar is closed */}
          {!toggle && window.innerWidth < 768 && (
            <div className="w-full flex gap-4 items-center p-[20px] fixed top-0 z-10 h-[60px] shadow-lg bg-[#F9F9F9] md:hidden">
              <button
                onClick={handleToggle}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md"
              >
                <img
                  src={ToggleIcon}
                  style={{ maxWidth: "none" }}
                  alt="Toggle Icon"
                  className="w-6 h-6"
                />
              </button>
              <div className="flex justify-center items-center gap-2 flex-grow">
                <img
                  src={Logo}
                  alt="SportGPT Logo"
                  className="w-8 h-8"
                />
                <span className="font-Poppins text-[24px] font-[700]">
                  Sports
                </span>
              </div>
              <button
                onClick={handleNewChat}
                className="p-[2px] hover:bg-[#e6e5e5] hover:rounded-md"
              >
                <img
                  src={NewChatIcon}
                  alt="New Chat Icon"
                  style={{ maxWidth: "none" }}
                  className="w-6 h-6"
                />
              </button>
            </div>
          )}

          <div className={`${displayFAQ ? "hidden" : "flex"}`}>
            <ToastContainer />
          </div>

          {/* Sidebar - now handles its own collapsed/expanded state */}
          <div
            ref={sidebarRef}
            className={`${toggle ? "w-[290px]" : "w-[60px]"} h-full transition-all duration-300 flex-shrink-0`}
          >
            <Sidebar
              toggle={toggle}
              setToggle={setToggle}
              chats={chats}
              setNewChat={setNewChat}
              newChat={newChat}
              onSelectChat={handleSelectChat}
              setSelectedChatId={setSelectedChatId}
              selectedChatId={selectedChatId}
              initials={initials}
              userName={userName}
              handleNewChat={handleNewChat}
              updateChats={fetchAllChats}
              setDisplayFAQ={setDisplayFAQ}
              displayFAQ={displayFAQ}
              setIsSettingsModalVisible={setIsSettingsModalVisible}
            />
          </div>

          {/* Main content area */}
          <div className="flex-1 flex flex-col">
            {/* LiveChat or FAQ content */}
            <div className={`relative flex-1 ${displayFAQ ? "hidden" : "flex"}`}>
              {loading ? null : (
                <LiveChat
                  chat={!newChat ? selectedChatMessages : null}
                  setNewChat={setNewChat}
                  newChat={newChat}
                  setIsModalOpen={setIsModalOpen}
                  updateMessages={fecthAllMessages}
                  updateChats={fetchAllChats}
                  setSelectedChatId={setSelectedChatId}
                  initials={initials}
                  userName={userName}
                  setSelectedFeedback={setSelectedFeedback}
                  toggle={toggle}
                  chats={chats}
                  setSelectedChatMessages={setSelectedChatMessages}
                  selectedChatId={selectedChatId}
                  handleSetIntroFlag={handleSetIntroFlag}
                />
              )}
            </div>
            <div className={`relative flex-1 ${displayFAQ ? "flex" : "hidden"}`}>
              <FAQ/>
            </div>
          </div>

          {isSettingsModalVisible && (
            <SettingsModal
              onClose={() => setIsSettingsModalVisible(false)} 
            />
          )}
        </div>
      )}
    </div>
  );
}

export default ConversationPage;